module.exports = __webpack_public_path__ + "img/virtual_tour.8c3fca25.jpg";